var _style, _path, _defs, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeonInmobiliariaIconsWohnflaeche = function SvgLeonInmobiliariaIconsWohnflaeche(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "leon-inmobiliaria-icons-wohnflaeche_svg__Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".leon-inmobiliaria-icons-wohnflaeche_svg__st0{display:none}.leon-inmobiliaria-icons-wohnflaeche_svg__st1{fill:currentcolor}.leon-inmobiliaria-icons-wohnflaeche_svg__st1,.leon-inmobiliaria-icons-wohnflaeche_svg__st2{display:inline}.leon-inmobiliaria-icons-wohnflaeche_svg__st3{fill:currentcolor}")), /*#__PURE__*/React.createElement("g", {
    id: "leon-inmobiliaria-icons-wohnflaeche_svg__Wohnfl\\xE4che"
  }, /*#__PURE__*/React.createElement("g", {
    id: "leon-inmobiliaria-icons-wohnflaeche_svg__Gruppe_9362_00000010309130829261270120000010832946749472527242_",
    transform: "translate(-754.538 -1133.08)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "leon-inmobiliaria-icons-wohnflaeche_svg__Pfad_5223_00000166673592280806642040000007235481141439187369_",
    className: "leon-inmobiliaria-icons-wohnflaeche_svg__st3",
    d: "M838.1 1216.9H771v-67.1h67.1v67.1zm4.7-71.8h-76.6v76.6h76.6v-76.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(761.323 1139.865)",
    id: "leon-inmobiliaria-icons-wohnflaeche_svg__Gruppe_8661_00000165930744548291875970000015830571433027532690_"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "leon-inmobiliaria-icons-wohnflaeche_svg__SVGID_1_",
    d: "M39 26.7H26.4v21H39v12.6h21V26.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "leon-inmobiliaria-icons-wohnflaeche_svg__SVGID_00000042003744242690902840000006994198911364960922_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#leon-inmobiliaria-icons-wohnflaeche_svg__SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "leon-inmobiliaria-icons-wohnflaeche_svg__Gruppe_8660_00000143603545440557767150000001359754339398013107_",
    style: {
      clipPath: "url(#leon-inmobiliaria-icons-wohnflaeche_svg__SVGID_00000042003744242690902840000006994198911364960922_)"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "leon-inmobiliaria-icons-wohnflaeche_svg__Pfad_5224_00000122708150362298441700000004440282573592593819_",
    className: "leon-inmobiliaria-icons-wohnflaeche_svg__st3",
    d: "M-9.9 50.9c-1.1 0-2-.9-2-2 0-.5.2-1 .6-1.4L44.3-8.2c.8-.8 2-.8 2.8 0 .8.8.8 2 0 2.8L-8.5 50.4c-.4.3-.9.5-1.4.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "leon-inmobiliaria-icons-wohnflaeche_svg__Pfad_5225_00000163764965087126829660000016972851988462078384_",
    className: "leon-inmobiliaria-icons-wohnflaeche_svg__st3",
    d: "M-1.9 58.9c-1.1 0-2-.9-2-2 0-.5.2-1 .6-1.4L52.3-.1c.8-.8 2-.8 2.8 0 .8.8.8 2 0 2.8L-.5 58.3c-.3.4-.8.6-1.4.6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "leon-inmobiliaria-icons-wohnflaeche_svg__Pfad_5226_00000114784168141743828590000009480585631437812110_",
    className: "leon-inmobiliaria-icons-wohnflaeche_svg__st3",
    d: "M6.2 66.9c-1.1 0-2-.9-2-2 0-.5.2-1 .6-1.4L60.4 7.8c.8-.8 2-.8 2.8 0 .8.8.8 2 0 2.8L7.6 66.4c-.4.3-.9.5-1.4.5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "leon-inmobiliaria-icons-wohnflaeche_svg__Pfad_5227_00000002383277999616880470000013657928423785986491_",
    className: "leon-inmobiliaria-icons-wohnflaeche_svg__st3",
    d: "M14.1 75c-1.1 0-2-.9-2-2 0-.5.2-1 .6-1.4l55.6-55.7c.8-.8 2-.8 2.8 0 .8.8.8 2 0 2.8L15.5 74.4c-.3.4-.8.6-1.4.6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "leon-inmobiliaria-icons-wohnflaeche_svg__Pfad_5228_00000182503977627609281100000004442411957146869387_",
    className: "leon-inmobiliaria-icons-wohnflaeche_svg__st3",
    d: "M22.2 83c-1.1 0-2-.9-2-2 0-.5.2-1 .6-1.4l55.6-55.7c.8-.8 2-.8 2.8 0 .8.8.8 2 0 2.8L23.6 82.5c-.4.3-.9.5-1.4.5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "leon-inmobiliaria-icons-wohnflaeche_svg__Pfad_5229_00000118362980519498147660000001832001538571916991_",
    className: "leon-inmobiliaria-icons-wohnflaeche_svg__st3",
    d: "M30.2 91.1c-1.1 0-2-.9-2-2 0-.5.2-1 .6-1.4L84.4 32c.8-.8 2-.8 2.8 0 .8.8.8 2 0 2.8L31.6 90.5c-.3.4-.8.6-1.4.6"
  })))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "leon-inmobiliaria-icons-wohnflaeche_svg__Pfad_5231_00000169536708894290343370000014958920006093956497_",
    className: "leon-inmobiliaria-icons-wohnflaeche_svg__st3",
    d: "M816.6 1171.3v24.1h-11.5v-12.6h-12.6v-11.5h24.1zm4.7-4.8h-33.6v21.1h12.6v12.6h21v-33.7z"
  })))));
};
export default SvgLeonInmobiliariaIconsWohnflaeche;